module.exports = __webpack_public_path__ + "static/media/IMG_5706.e5ef71d4.JPG";